import { setSafe } from "../../../util/storeHelper";
import * as actions from "../actions/settings";
import * as path from "path";
/**
 * reducer for changes to ephemeral session state
 */
export const settingsReducer = {
    reducers: {
        [actions.setMaxDownloads]: (state, payload) => setSafe(state, ["maxParallelDownloads"], payload),
        [actions.setDownloadPath]: (state, payload) => setSafe(state, ["path"], payload),
        [actions.setShowDLDropzone]: (state, payload) => setSafe(state, ["showDropzone"], payload),
        [actions.setShowDLGraph]: (state, payload) => setSafe(state, ["showGraph"], payload),
        [actions.setCopyOnIFF]: (state, payload) => setSafe(state, ["copyOnIFF"], payload),
        [actions.setMaxBandwidth]: (state, payload) => setSafe(state, ["maxBandwidth"], payload),
        [actions.setCollectionConcurrency]: (state, payload) => setSafe(state, ["collectionsInstallWhileDownloading"], payload),
    },
    defaults: {
        minChunkSize: 1024 * 1024,
        maxChunks: 10,
        maxParallelDownloads: 1,
        maxBandwidth: 0,
        path: path.join("{USERDATA}", "downloads"),
        showDropzone: true,
        showGraph: true,
        copyOnIFF: false,
        collectionsInstallWhileDownloading: true,
    },
    verifiers: {
        path: {
            description: () => "Severe! The download folder is invalid and will be reset",
            type: "string",
        },
    },
};
